import { render } from "./StatMo.vue?vue&type=template&id=13cbc93a&scoped=true"
import script from "./StatMo.vue?vue&type=script&lang=js"
export * from "./StatMo.vue?vue&type=script&lang=js"

import "./StatMo.vue?vue&type=style&index=0&id=13cbc93a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cbc93a"]])

export default __exports__